export default __webpack_public_path__ + "static/media/Trading_Window_Closure_April_June_2025.eed8535c.pdf";